import { useState, useEffect } from "react";
import { Client } from "@microsoft/microsoft-graph-client";
import { useMsal } from "@skanska/vsa-client-auth";
import GraphClientService from "../services/GraphClientService";

export const useGraphClient = () => {
  const [graphClient, setGraphClient] = useState<Client | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { instance, inProgress } = useMsal();

  useEffect(() => {
    const initializeClient = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const graphService = GraphClientService.getInstance();
        const client = await graphService.initializeGraphClient(
          inProgress,
          instance,
          import.meta.env.VITE_TENANT_ID
        );

        setGraphClient(client);
      } catch (err) {
        console.error("Failed to initialize Graph client:", err);
        setError(err instanceof Error ? err.message : "Unknown error");
      } finally {
        setIsLoading(false);
      }
    };

    // Only initialize when MSAL is ready
    if (inProgress === "none") {
      initializeClient();
    }
  }, [inProgress, instance]);

  return {
    graphClient,
    isLoading,
    error,
  };
};
